module.exports = __webpack_public_path__ + "static/about_banner-923e9f9caa3183850c884aae1860b983.svg";